import { Column } from 'declarations/types/common';

export const columns: Column[] = [
  { id: '1', label: 'Priority', visible: true, isRequired: false },
  { id: '2', label: 'RO number', visible: true, isRequired: true },
  { id: '3', label: 'Line number', visible: true, isRequired: false },
  { id: '4', label: 'Status', visible: true, isRequired: true },
  { id: '5', label: 'Age (days)', visible: true, isRequired: false },
  { id: '6', label: 'Claim Age (days)', visible: true, isRequired: false },
  { id: '7', label: 'Assigned to:', visible: true, isRequired: true },
  { id: '9', label: 'Category', visible: true, isRequired: true },
  { id: '10', label: 'Last Comment', visible: true, isRequired: false },
  { id: '11', label: 'Claim Status', visible: true, isRequired: false },
  { id: '12', label: 'Amount', visible: true, isRequired: false },
  { id: '13', label: 'Advisor number', visible: true, isRequired: false },
  { id: '14', label: 'Tech number', visible: true, isRequired: false },
  { id: '15', label: 'Attachment', visible: true, isRequired: false },
  { id: '16', label: 'Approved', visible: true, isRequired: false },
  { id: '17', label: 'Subcategory', visible: true, isRequired: false },
  { id: '18', label: 'Closed RO Age', visible: true, isRequired: false },
];
